import { FC } from 'react';
import { generate } from 'short-uuid';

const IndentLines: FC<{
  showLines?: boolean;
  depth: number;
  height?: number;
  width?: number;
  stroke?: string;
}> = ({
  depth,
  height = 24,
  width = 11,
  showLines = true,
  stroke = 'rgb(241, 245, 249)',
}) => {
  const uniqueId = `indent_line_${generate()}`;

  return (
    <svg
      viewBox={`0 0 ${11 * depth} 24`}
      width={`${11 * depth}`}
      height={height}
    >
      <defs>
        <pattern
          id={uniqueId}
          x="0"
          y="0"
          width={width}
          height={height}
          patternUnits="userSpaceOnUse"
        >
          <line
            x1={width / 2}
            y1="0"
            x2={width / 2}
            y2={height}
            stroke={stroke}
          ></line>
        </pattern>
      </defs>
      {showLines ? (
        <rect
          fill={`url(#${uniqueId})`}
          x="0"
          y="0"
          width={`${11 * depth}`}
          height={height}
        ></rect>
      ) : (
        <rect
          fill={showLines ? `url(#${uniqueId})` : ''}
          x="0"
          y="0"
          width={0}
          height={height}
        ></rect>
      )}
    </svg>
  );
};

export default IndentLines;
